import { AbstractControl } from '@angular/forms';

export function validateDecimal(c: AbstractControl) {
    let DECIMAL_REGEX = /^\d{1}(\.\d{1,2})?$/;

    // If the value of the control tests against the regex, there is no error (return null).
    return (c.value == null || c.value == '' || DECIMAL_REGEX.test(c.value) ? null : {
        validateDecimal: {
            valid: false
        }
    });
}